import React, {Component} from 'react';
import PieChart from 'react-minimal-pie-chart';
import moment from 'moment';
import { Sparklines, SparklinesBars } from 'react-sparklines';
import { Scrollbars } from 'react-custom-scrollbars';

class TestResultsModal extends Component {

    constructor(props){
        super(props);

        this.state = {
            test: this.props.test,
            sections: this.props.test.sections,
            activeSection: 0
        }
    }

    renderQuestions = () => {
        return this.props.test.questions.map(question => {
            return (
                <div className={"question-container"}>
                    <h4>
                        {(question.userAnswer == question.correctOption) ?
                            <span className={"zmdi zmdi-check text-success"}></span>
                            :
                            <span className={"zmdi zmdi-close text-danger"}></span>
                        }
                        &nbsp;
                        {question.question}</h4>

                    <div className={(question.userAnswer == "A" && question.correctOption == "A" || question.correctOption == "A") ? "answer text-success" :
                        (question.userAnswer == "A" && question.correctOption != "A") ? "answer text-danger" : "answer"}>
                        <b>A:</b> {question.optionA}

                    </div>
                    <div className={(question.userAnswer == "B" && question.correctOption == "B" || question.correctOption == "B") ? "answer text-success" :
                        (question.userAnswer == "B" && question.correctOption != "B") ? "answer text-danger" : "answer"}>
                        <b>B:</b> {question.optionB}

                    </div>
                    <div className={(question.userAnswer == "C" && question.correctOption == "C" || question.correctOption == "C") ? "answer text-success" :
                        (question.userAnswer == "C" && question.correctOption != "C") ? "answer text-danger" : "answer"}>
                        <b>C:</b> {question.optionC}

                    </div>
                    <div className={(question.userAnswer == "D" && question.correctOption == "D" || question.correctOption == "D") ? "answer text-success" :
                        (question.userAnswer == "D" && question.correctOption != "D") ? "answer text-danger" : "answer"}>
                        <b>D:</b> {question.optionD}

                    </div>
                </div>
            )
        })
    }

    renderSingleQuestion(question, index){
        let userAnswer = question.userAnswer;
        let correct = question.correctOption;
        return (
            <div className="table-question-row">
                <ul>
                    <li className="question-number">{index + 1}</li>
                    <li className={(correct == userAnswer && correct == "A") ?
                        "QuestionAble CorrectQuestion" :
                        (correct != userAnswer && userAnswer == "A") ?
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "A") ?
                                "QuestionAble SuggestedAnswer" : "QuestionAble"}>

                        <input type="radio" id={"question-" + index + "A"} name={"question-" + index} value="A"

                        />
                        <label for={"question-" + index + "A"}>A</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "B") ? 
                        "QuestionAble CorrectQuestion" : 
                        (correct != userAnswer && userAnswer == "B") ? 
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "B") ?
                                "QuestionAble SuggestedAnswer" : "QuestionAble"}>

                    <input type="radio" id={"question-" + index + "B"} name={"question-" + index} value="B"

                        />
                        <label for={"question-" + index + "B"}>B</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "C") ?
                        "QuestionAble CorrectQuestion" :
                        (correct != userAnswer && userAnswer == "C") ?
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "C") ?
                                "QuestionAble SuggestedAnswer" : "QuestionAble"}>
                    <input type="radio" id={"question-" + index + "C"} name={"question-" + index} value="C"

                        />
                        <label for={"question-" + index + "C"}>C</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "D") ?
                        "QuestionAble CorrectQuestion" :
                        (correct != userAnswer && userAnswer == "D") ?
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "D") ?
                                "QuestionAble SuggestedAnswer" : "QuestionAble"}>
                    <input type="radio" id={"question-" + index + "D"} name={"question-" + index} value="D"

                        />
                        <label for={"question-" + index + "D"}>D</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "E") ?
                        "QuestionAble CorrectQuestion" :
                        (correct != userAnswer && userAnswer == "E") ?
                            "QuestionAble InCorrectAnswer" :
                            (correct != userAnswer && correct == "E") ?
                                "QuestionAble SuggestedAnswer" : "QuestionAble"}>
                    <input type="radio" id={"question-" + index + "E"} name={"question-" + index} value="E"

                        />
                        <label for={"question-" + index + "E"}>E</label>
                        <div className="selected"></div>
                    </li>
                    <li className={(correct == userAnswer && correct == "E") ? "CorrectQuestion" : (correct != userAnswer && userAnswer == "E") ? "InCorrectAnswer" : "" }>

                    <input type="checkbox" id="Option<?php echo $x ?>Q" name="QuestionHELP<?php echo $x ?>" value="HELP"/>
                        <label for="Option<?php echo $x ?>Q">?</label>
                        <div className="selected"></div>
                    </li>

                </ul>
                <div className="question-details">
                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A debitis dolor est inventore maiores nihil quae quasi quo rerum vero! Alias dicta enim error, fugiat harum in ipsa provident ut?</p>
                </div>
            </div>
        )
    }

    renderResults = () => {

        let guesses = 0;

        this.props.test.sections.map(s => {
            guesses += s.questions.filter(q => !q.userAnswer).length
        })
        return (
            <div>

                <div className="b-b wrapper-md">
                    <div className="row">
                        <div className="col-sm-8">
                            <h1 className="m-n font-thin h3 text-black">{this.props.test.title}</h1>
                            <small className="text-muted">{this.props.test.instructions}</small>

                        </div>
                        <div className="col-sm-4 text-right">


                         </div>
                    </div>
                </div>

                <div className="content no-padding bg-white">
                    <div className="sp-20 score_summary_result b-b">
                        <div className="row">
                            <div className="col-sm-3">
                                <div className="">
                                    <p>Your Score</p>
                                    <h3>{this.props.test.correctAnswers} / {this.props.test.totalQuestions}</h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="">
                                    <p>Correct Answers</p>
                                    <h3>{this.props.test.correctAnswers}</h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="">
                                    <p>Incorrect Answers</p>
                                    <h3>{this.props.test.totalQuestions - this.props.test.correctAnswers}</h3>
                                </div>
                            </div>
                            <div className="col-sm-3">
                                <div className="">
                                    <p>Guess Work</p>
                                    <h3>{guesses}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.props.test.correctPercent < 80 && !this.props.onboarding &&
                        <div className="retake-subject text-red">
                            Unfortunately, you didn't pass this test.  We're setting things up so you can take this subject again.  When you're ready, hit the continue button to get started.
                        </div>
                    }
                    <form method="post" className="sp-20 results-score" id="finalScoreForm">
                        <div className="row">
                            <div className="table-question sm-bottom0">
                            {this.props.test.sections.map((section, index) => {
                                return (
                                    <div>
                                        <div className={"pull-right"}>
                                            <div className="video-question-summary">
                                                <PieChart
                                                    style={{width: 50, margin: '0 auto'}}
                                                    data={[
                                                        {value: section.correctPercent, color: '#555'},
                                                        {value: section.correctAnswers, color: '#e33339'}
                                                    ]}
                                                    totalValue={section.questions.length}
                                                    lineWidth={10}
                                                    rounded={true}
                                                />
                                                <p className="diagnostic-pie-chart-counter">{section.correctPercent}%</p>
                                            </div>
                                        </div>
                                        <div>
                                        <h4 className={"text-left"}>Section {index + 1} {section.name ? "- " + section.name : ''}</h4>
                                        <p className={"text-left"}>
                                           <div>
                                               <b>Correct Answers:</b> {section.correctAnswers}/{section.questions.length}
                                           </div>
                                            <div>
                                                <b>Incorrect Answers:</b> {section.incorrectAnswers}/{section.questions.length}
                                            </div>

                                        </p>
                                        </div>
                                        <div>
                                            {section.questions.map((q, i) => {
                                                return this.renderSingleQuestion(q, i)
                                            })}
                                        </div>
                                        <br /><br />
                                    </div>
                                )
                            })}
                            </div>
                        </div>
                    </form>
                    </div>
                    </div>
        )
    }

    render(){
        let options = ['0', 'A', 'B', 'C', 'D', 'E'];

        
        return (
            <div className="modal fade in show" id="FinalScoreModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel">
                <div className="modal-dialog modal-lg" role="document">
                <Scrollbars style={{ height: "calc(100vh - 100px)" }}>
                    <div className="modal-content light-text test-result-modal">
                        <div className="modal-header">
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title" id="myModalLabel">Test Summary</h4>
                        </div>
                        <div className="modal-body">
                        {this.state.test ? 
                            this.state.test.id ?
                        <div className="FinalAnswerToMCQ sp-20">
                            <div className="clearfix">
                                <div className="pull-left">
                                    <p className="font-30 font-300 sm-bottom30">Test Results</p>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-sm-3">
                                    <p className="no-margin">Correct</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="80">{this.props.test.correctAnswers}</p>
                                </div>
                                <div className="col-sm-3">
                                    <p className="no-margin">Incorrect</p>
                                    <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="14">{this.props.test.totalQuestions - this.state.test.correctAnswers}</p>
                                </div>
                                {this.props.test.timeLimit ?
                                    <div className="col-sm-3">
                                        <p className="no-margin">Time Taken</p>
                                        <p className="font-60 roboto font-300 no-margin line-height-1 counter" data-to="14">
                                            {this.props.test.timeLimit - this.state.test.completedIn > 0 ?
                                                moment.utc(moment.duration((this.props.test.completedIn) * 1000).as('milliseconds')).format('HH:mm:ss')
                                            : '00:00'}
                                        </p>
                                    </div>
                                :
                                <div className="col-sm-3">
                                </div>
                                }


                                <div className="col-sm-3">
                                    <div className="video-question-summary">
                                        <PieChart
                                            style={{width: 80, margin: '0 auto'}}
                                            data={[
                                                {value: 100, color: '#555'},
                                                {value: this.props.test.correctPercent, color: '#e33339'}
                                            ]}
                                            totalValue={100}
                                            lineWidth={10}
                                            rounded={true}
                                        />
                                        <p className="diagnostic-pie-chart-counter quiz-results-pie">{this.props.test.correctPercent}%</p>
                                    </div>

                                    </div>
                            </div>
                            <p className="font-30 roboto font-300 sm-top-bottom50">Final Result:
                                {this.props.test.correctPercent >= 80 ?
                                <span className="text-success"> {this.props.test.correctPercent >= 100 ? 'Perfect!' : 'Pass' }</span>
                                    :
                                    <span className="text-danger"> Failed</span>}

                                    </p>
                            {this.props.profile.role === 'admin' ?
                                <div>
                                {this.props.test.practice && !this.props.test.diagnostictestId &&
                                    !this.props.test.passed ?
                                        this.props.test.failBehavior === 'lecture' ?
                                            <p className="light-text">You failed this test.  When you're ready to give it another go, click Continue.</p>
                                        : <p className="light-text">You failed this test.  This means you'll have to start this subject again.  When you're ready to give it another go, click Continue.</p>
                                    :
                                    !this.props.test.passed ?
                                        this.props.test.failBehavior === 'lecture' ?
                                            <p className="light-text">You failed this test.  When you're ready to give it another go, click Continue.</p>
                                        : <p className="light-text">You failed this test.  This means you'll have to start this subject again.  When you're ready to give it another go, click Continue.</p>
                                    :
                                    <p className="light-text">You've completed the test.  You can now continue with your course.</p>
                                }
                                <button className="btn btn-danger" onClick={(e) => this.props.continue(e)}>Continue <i className="zmdi zmdi-arrow-forward"></i> </button> &nbsp;
                                <button className="btn btn-success" onClick={(e) => this.props.toCourseAdmin(e)}>Back To Course Admin <i className="zmdi zmdi-arrow-back"></i> </button> &nbsp;
                                
                                </div>
                            : 
                                    <div>
                                    {this.props.test.practice && !this.props.test.diagnostictestId &&
                                        !this.props.test.passed ?
                                            this.props.test.failBehavior === 'lecture' ?
                                                <p className="light-text">You failed this test.  When you're ready to give it another go, click Continue.</p>
                                            : <p className="light-text">You failed this test.  This means you'll have to start this subject again.  When you're ready to give it another go, click Continue.</p>
                                        :
                                        !this.props.test.passed ?
                                            this.props.test.failBehavior === 'lecture' ?
                                                <p className="light-text">You failed this test.  When you're ready to give it another go, click Continue.</p>
                                            : <p className="light-text">You failed this test.  This means you'll have to start this subject again.  When you're ready to give it another go, click Continue.</p>
                                        :
                                        <p className="light-text">You've completed the test.  You can now continue with your course.</p>
                                    }
                                    <button className="btn btn-danger" onClick={(e) => this.props.continue(e)}>Continue <i className="zmdi zmdi-arrow-forward"></i> </button>
                                    </div>
                            }

                            

                            <table className="table">
                                <tbody>
                                <tr>
                                    <th className="text-center" style={{width: 50}}>Result</th>
                                    <th className="text-center" style={{width: 100}}>Answered</th>
                                    <th className="text-left">Question</th>
                                    <th className="text-center" style={{width: 122}}>Time Taken</th>
                                </tr>
                                {
                                    this.props.test.sections &&
                                    this.props.test.sections.map((section, si) => {
                                        
                     
                                            return section.questions.map((a, i) => {
                                                let seconds = 0;
                                                let timer = "";
                                                if(a.time){
                                                    seconds = parseInt(a.time % 60);
                                                    timer = (seconds < 10) ? parseInt(a.time / 60) + ":" + "0" + seconds.toString()
                                                        : parseInt(a.time / 60) + ":" + seconds.toString();
                                                }
                                                return (
                                                    <tr key={i}>
                                                        <td className="text-center"><i className={(a.userAnswer === a.correctOption) ? "zmdi zmdi-check text-success  font-24" : "zmdi zmdi-close text-danger font-24"}></i></td>
                                                        <td className="text-center">
                                                            {a.userAnswer}
                                                        </td>
                                                        <td className="text-left">
                                                            <p className="font-14" data-toggle="collapse" data-target={`#LECTURETEST-${si}-${i}`} aria-expanded="false" aria-controls={`#LECTURETEST-${si}-${i}`} dangerouslySetInnerHTML={{__html: a.question}}></p>
                                                            <div className="modalQuizeAnswersOptions collapse" id={`LECTURETEST-${si}-${i}`}>
                                                                            {options.filter(o => o !== '0').map((o, oi) => {
                                                                                if(o === "E"){
                                                                                    return (
                                                                                        <div className="modalQuizeAnswers" key={oi}>
                                                                                            <div class={`AnsOption ${a.correctOption === o ? 'bg-success' : a.userAnswer === o ? 'bg-danger' : ''}`}>{o}</div>
                                                                                            <div className="AnsText" dangerouslySetInnerHTML={{__html:"<p>I don't know</p>"}}></div>
                                                                                        </div>
                                                                                    )
                                                                                }else{
                                                                                    return (
                                                                                        <div className="modalQuizeAnswers" key={oi}>
                                                                                            <div class={`AnsOption ${a.userAnswer === o ? a.userAnswer === a.correctOption ? 'bg-success' : 'bg-danger' : ''}`}>{o}</div>
                                                                                            <div className="AnsText" dangerouslySetInnerHTML={{__html: a["option" + o]}}></div>
                                                                                        </div>
                                                                                    )
                                                                                }
                                                                                
                                                                            })}
                                                                            
                                                                        </div>
                                                        </td>
                                                        <td className="text-center">{timer}</td>
                                                    </tr>
                                                )
                                            })
                                        

                                })}
                                </tbody>
                            </table>
                        </div>
                        : null
                        : null }
                        </div>

                    </div>
                    </Scrollbars>
                </div>
            </div>
        )
                
        return (
            <div
                className={`bootbox modal fade bootbox-confirm in`}
                tabIndex="-1"
                role="dialog"
                style={{
                    display: "block",
                    paddingRight: 15
                }}
            >
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-body">
                            <button
                                type="button"
                                className="bootbox-close-button close"
                                data-dismiss="modal"
                                aria-hidden="true"
                                style={{marginTop: -10}}
                                onClick={() => this.props.hideModal()}
                            >
                                ×
                            </button>
                            <div className="bootbox-body">
                                <div className="sp-10 font-16">
                                    {this.renderResults()}
                                </div>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button className="btn btn-base btn-lg" onClick={(e) => this.props.continue(e)}>Continue <i className="zmdi zmdi-arrow-forward"></i> </button>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default TestResultsModal;


// WEBPACK FOOTER //
// ./src/components/UserCourse/TestResultsModal.js